import type PersistedState from "~/domains/store/PersistedState";

export interface UserInfo {
  address1: string;
  city: string;
  state: string;
  zip: string;
  cust_No: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  member_since?: Date;
}

export interface BranchMgrInfo {
  name: string | undefined,
  signatureImageSrc: string,
  franchiseeImageSrc: string | undefined,
  socialUrls: Object,
  franchiseEmail: string | undefined,
  phone: string | undefined,
  address: string,
  designation: string | undefined,
  region: string | undefined,
  location: string,
}

export function getUserInfo(persistedState: PersistedState): UserInfo {
  const customer = persistedState.customer;
  const userAddressParts = persistedState.userAddress?.split(",");

  return {
    address1: (customer?.address?.addressLine1 ?? customer?.address1 ?? userAddressParts[0])?.trim(),
    city: (customer?.address?.city ?? customer?.city ?? userAddressParts[1])?.trim(),
    state: (customer?.address?.state ?? customer?.state ?? userAddressParts[2])?.trim(),
    zip: (customer?.address?.zip ?? customer?.zip ?? userAddressParts[3])?.trim().slice(0, 5),
    cust_No: customer?.id ?? persistedState.cust_No,
    firstName: (customer?.firstName ?? "")?.trim(),
    lastName: (customer?.lastName ?? "")?.trim(),
    email: (customer?.email ?? "")?.trim(),
    member_since: customer?.since,
  };
}

export function getBranchMgrInfo(persistedState: PersistedState): BranchMgrInfo {
  const config = useRuntimeConfig();
  const branchInfo = persistedState.branchInfo?.BranchInfo;

  const marketRegion = branchInfo?.InfoData?.find(data => data.FieldName === "Marketing Metro Region");
  // const phoneData = branchInfo.InfoData.find(data => data.FieldName === "Business Main Phone");
  const nameData = branchInfo?.InfoData?.find(data => data.FieldName === "Franchise Owner Name");
  const designationData = branchInfo?.InfoData?.find(data => data.FieldName === "Franchise Owner Title");
  const streetAddress = branchInfo?.InfoData?.find(data => data.FieldName === "Mailing Address");
  const city = branchInfo?.InfoData?.find(data => data.FieldName === "Mailing City");
  const state = branchInfo?.InfoData?.find(data => data.FieldName === "Mailing State");
  const zipcode = branchInfo?.InfoData?.find(data => data.FieldName === "Mailing Zip Code");
  const franchiseEmailData = branchInfo?.InfoData?.find(data => data.FieldName === "Primary Owner Email");
  const fbUrl = branchInfo?.InfoData?.find(data => data.FieldName === "Facebook URL");
  const gUrl = branchInfo?.InfoData?.find(data => data.FieldName === "Google URL");
  const youtubeUrl = branchInfo?.InfoData?.find(data => data.FieldName === "YouTube Intro URL");

  const socialUrls = { fb: fbUrl, google: gUrl, youtube: youtubeUrl };
  const addressData = `${streetAddress?.FieldValue} , ${city?.FieldValue} , ${state?.FieldValue} , ${zipcode?.FieldValue}`;

  const franchiseData = persistedState.franchiseData;
  const franchiseePhoto = franchiseData.franchise_owner_image ? `${config.public.sgCmsImage}${franchiseData.franchise_owner_image}` : undefined;

  return {
    name: nameData?.FieldValue,
    signatureImageSrc: "",
    franchiseeImageSrc: franchiseePhoto,
    socialUrls: socialUrls,
    franchiseEmail: franchiseEmailData?.FieldValue,
    phone: persistedState.branchPhone?.FieldValue,
    address: addressData,
    designation: designationData?.FieldValue,
    region: marketRegion?.FieldValue,
    location: persistedState.branchLocation,
  };
}
